import React from 'react';
import { Leaf } from 'lucide-react';
export function SustainabilitySection() {
  return <section className="relative py-[60px] md:py-[80px] lg:py-[120px] px-6 text-center overflow-hidden" data-id="element-158">
      {/* Background Image */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-fixed" style={{
      backgroundImage: "url('https://assets.modern-commerce.io/Glenlofty%20Project%20Files/lucinda-wang-nMWMsOowOyc-unsplash.jpg')"
    }} data-id="element-159" />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/60 z-[1]" data-id="element-160"></div>

      {/* Content */}
      <div className="relative z-10 max-w-[1000px] mx-auto flex flex-col items-center" data-id="element-161">
        <div className="mb-6 p-4 border-2 border-white" data-id="element-162">
          <Leaf className="w-12 h-12 text-white" data-id="element-163" />
        </div>

        <h2 className="text-[32px] md:text-[40px] text-white mb-6 font-[500]" data-id="element-164">
          Certified Organic & Sustainable
        </h2>

        <p className="text-body text-white/95 max-w-3xl" data-id="element-165">
          Glenlofty Estate is certified organic and a proud member of
          Sustainability Winegrowing Australia (SWA). Organic certification
          ensures healthier soils, stronger vines, and increased biodiversity.
          Through SWA, we continuously benchmark and improve environmental,
          social, and economic practices — including water, energy, waste, and
          community engagement.
        </p>
      </div>
    </section>;
}